/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TopicsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    return this.store
      .query('goals/subject', { visibleToTeachers: true })
      .then((subjects) => {
        const filteredSubjects = subjects.filter((subject) => subject.isTopic);
        const group = this.modelFor('group');

        // Query states for each subject
        const statesQueries = filteredSubjects.map((subject) =>
          this.store.query('goals/state', {
            subjectId: subject.id,
            groupId: group.id,
            current: true,
            include: 'goals',
          }),
        );

        return Promise.all(statesQueries).then((states) => {
          return hash({
            subjects: filteredSubjects,
            group,
            states,
          });
        });
      });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = sortBy(model.subjects, 'label');
  }

  init() {
    super.init(...arguments);
    this.router.on('routeDidChange', (transition) => {
      if (transition.to?.find((route) => route.name === this.routeName)) {
        // Set activeSubject on the controller so that it can highlight the correct button.
        let params = this.paramsFor(transition.targetName);
        let props = {
          activeSubject: params.subject_id,
        };
        if (transition.targetName === 'group.topics.index') {
          props.tab = 'current';
        }
        this.controller.setProperties(props);
      }
    });
  }
}
